<template>
	<div class="oldNaviDots" @mouseenter="active = isTouch ? active : true" @mouseleave="active = isTouch ? active : false" @click="active = isTouch ? !active : active">	
		<span class="icon ellipsis-v"></span>
		<div v-show="active" class="arrowTop"></div>
		<div v-show="active" class="oldEditMenuContainer">
			<div v-if="canEdit"><a @click="editUserContent">Bearbeiten</a></div>
			<div v-if="canDelete"><a @click="deleteUserContentConfirmation">Löschen</a></div>
			<div v-if="canReply"><a @click="replyUserContent">Antworten</a></div>
			<div v-if="canCopy"><a v-clipboard="contentkey" @success="handleCopySuccess" @error="handleCopyError">Kopieren</a></div>
			<!-- <div><a href="">Teilen</a></div> -->
		</div>	
        <!-- Modal -->
        <div ref="modalDialog" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog old-modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Bestätigung</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Möchten Sie diesen Inhalt wirklich löschen?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Nein</button>
                    <button @click="deleteUserContent" type="button" class="btn btn-primary" data-dismiss="modal">Ja</button>
                </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    import Modernizr from 'modernizr';
	export default {
		name: 'userContentEditPanel',
		props: {
            project: String,
            contenttype: String,
            contentkey: String,
            contentactions: Array
        },
        data: function() {
        	return {
                active: false,
                isTouch: false,
                canEdit: false,
                canDelete: false,
                canReply: false,
                canCopy: false
        	}
        },
        created: function() {
            if (Modernizr.touchevents) {
                this.isTouch = true;
            }
            this.canEdit = this.contentactions.indexOf('EDIT') >= 0;
            this.canDelete = this.contentactions.indexOf('DELETE') >= 0;
            this.canReply = this.contentactions.indexOf('REPLY') >= 0;
            this.canCopy = this.contentactions.indexOf('COPY') >= 0;
        },
        methods: {
            editUserContent: function() {
                this.active = false;
                window.location.href = '/project/' + this.project + '/content.html?kind=' + this.contenttype + '&key=' + this.contentkey;
            },
            replyUserContent: function() {
                this.active = false;
                window.location.href = '/project/' + this.project + '/content.html?kind=reply&replykey=' + this.contentkey;
            },
            deleteUserContentConfirmation: function() {
                this.active = false;
                jQuery(this.$refs.modalDialog).modal('show');
            },
            handleCopySuccess(e) {
                console.log(e);
            },
            handleCopyError(e) {
                console.log(e);
            },
            deleteUserContent: function() {

                var self = this;
                console.log('loading content ' + self.contentkey);
                jQuery.ajax ({
                    url: '/project/' + self.project + '/content/' + self.contentkey,
                    type: 'DELETE',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        console.log('receiving delete response ' + data);
                        location.reload();
                    },
                    error: function() {alert("error");}
                });
            }
        }
	}
</script>


// WEBPACK FOOTER //
// UserContentEditPanel.vue?27097ff8